import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  ISortOptionsModel,
  ITrackerConfigModel,
  TrackerViewsEnum,
  TrackersEnum,
} from "../../models/TrackerModel";
import { Button } from "reactstrap";
import { Modal as ModalPopup } from "react-bootstrap";
import {
  ILeadTrackerConfigModel,
  IMenuOptionsModel,
  ITrackerResponseModel,
  TrackerModule,
} from "nfg-tracker-module";

import FilterIcon from "../../images/filter-icon.svg";
import GridViewIcon from "../../images/grid-view.svg";
import GridViewInActiveIcon from "../../images/grid-view-inactive.svg";
import ListViewIcon from "../../images/list-view.svg";
import ListViewInActiveIcon from "../../images/list-view-inactive.svg";
import FilterLeads from "../Filters/FilterLeads";

import CreateLeadMaster from "../layout/Leads/CreateLeadMaster";
import ListViewTracker from "./ListViewTracker";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Service from "../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { AxiosError, AxiosResponse } from "axios";
import { catchError } from "../../utils/Utils";
import { QUESTIONNAIRE_TYPES, RoutesEnum } from "../../utils/RoutesUtil";
import { BankUserContext } from "../../bankUserContext";
import { toast } from "react-toastify";
import {
  clearFilters,
  getFilterValue,
  getSearchValue,
  setFilters,
  setSearch,
} from "../Filters/FiltersHelper";

import "./tracker.scss";
import { ActionBtnTypes, IActionBtnsModel } from "../../models/StatusTabModel";
import FinSpinner from "../../commonfields/FinSpinner";
import { error } from "console";
import { catchErrorGeneric } from "../../utils/GeneralUtils";

interface IGenericTrackerProps {
  baseConfig: ITrackerConfigModel;
  trackerConfig: ILeadTrackerConfigModel[];
  trackerData: ITrackerResponseModel[];
  trackerListConfig?: any;
  handleGenericData?: any;
  cardHandler?: Function;
  resetTracker: boolean;
  setResetTracker: (value: boolean) => void;
  setTrackerData: (extraFields: any) => Promise<void>;
}

const GenericTracker = (props: IGenericTrackerProps) => {
  const {
    baseConfig,
    trackerConfig,
    trackerData,
    trackerListConfig,
    cardHandler,
    resetTracker,
    setResetTracker,
    setTrackerData,
  } = props;

  const service = new Service();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const { bankuserDetails } = useContext(BankUserContext);

  // data states

  // component states
  // const [rSelected, setRSelected] = useState(1);
  const [selectedClient, setSelectedClient] = useState<any>({});
  const [tileDropdown, setTileDropdown] = useState("");
  const [trackerView, setTrackerView] = useState(TrackerViewsEnum.GRID);
  const [filterModal, setFilterModal] = useState(false);
  const [filtersData, setFiltersData] = React.useState<any>(null);
  const [selectedFilters, setSelectedFilters] = React.useState<any>(null);
  const [trackerSearch, setTrackerSearch] = React.useState("");
  const [menuOption, setMenuOption] = useState<any>({});
  const [activeFilter, setactiveFilter] = useState(false);

  const [sortOptions, setSortOptions] = useState<ISortOptionsModel | null>(
    null
  );
  const [innerLoader, setInnerLoader] = useState(false);
  const currentUrl = window.location.href;
  const context = useContext(BankUserContext);

  const assignmentsObj = [{ value: "My Leads", text: "My Leads" }];
  const getTrackerType = useMemo(() => {
    const getTrackerTypeList = location?.pathname?.split("/");
    return getTrackerTypeList?.[2] || TrackersEnum.DEFAULT;
  }, [location]);

  const toggleTileDropdown = (value: any, e: any) => {
    e?.stopPropagation();
    if (tileDropdown === value) {
      setTileDropdown("");
    } else {
      setTileDropdown(value || "");
    }
  };

  const handleTrackerSearch = (value: string) => {
    setTrackerSearch(value);
    setSearch(getTrackerType, value);
    // setInnerLoader(true);
    setTrackerData({
      search: value,
      ...selectedFilters,
    });
    // setTimeout(() => {
    //   setInnerLoader(false);
    // }, 100);
  };

  const getModifiedFilterValues = (filters: any) => {
    if (filters) {
      return {
        states: filters?.states?.map((m: any) => m.value),
        productType: filters?.productType?.map((m: any) => m.value),
        industryTypes: filters?.industryTypes?.map((m: any) => m.value),
        salesOrganizations: filters?.salesOrganizations?.map(
          (m: any) => m.value
        ),
        teamMembers: filters?.assignmentType?.map((m: any) => m.value),
        nextAction: filters?.nextAction
          ? moment(filters?.nextAction).format("MM/DD/YYYY")
          : null,
        expectedClose: filters?.expectedClose
          ? moment(filters?.expectedClose).format("MM/DD/YYYY")
          : null,
        archive: filters?.archive
      };
    } else return {};
  };

  useEffect(() => {
    const trackerView = localStorage.getItem(`${getTrackerType}-trackerView`);
    if (trackerView) {
      setTrackerView(
        trackerView === "grid" ? TrackerViewsEnum.GRID : TrackerViewsEnum.LIST
      );
    } else {
      setTrackerView(TrackerViewsEnum.GRID);
    }
    getFilters();
    const getLocalStorageFilterValues = getFilterValue(getTrackerType);
    const getLocalStorageSerachValue = getSearchValue(getTrackerType);

    setTrackerSearch(getLocalStorageSerachValue);
    setSelectedFilters(getLocalStorageFilterValues);

    const filterValues = getModifiedFilterValues(getLocalStorageFilterValues);

    setTrackerData({
      search: getLocalStorageSerachValue,
      ...(sortOptions?.sortColumn ? sortOptions : {}),
      ...filterValues,
    });
  }, [location?.pathname]);

  const clearAllfiltervalues = () => {
    setSelectedFilters(null);
    clearFilters();
    setTrackerData(null);
  };

  useEffect(() => {
    if (resetTracker) {
      const trackerView = localStorage.getItem(`${getTrackerType}-trackerView`);
      if (trackerView) {
        setTrackerView(
          trackerView === "grid" ? TrackerViewsEnum.GRID : TrackerViewsEnum.LIST
        );
      } else {
        setTrackerView(TrackerViewsEnum.GRID);
      }
      setResetTracker(false);
    }
  }, [resetTracker]);

  const getFilters = () => {
    const postData = {
      sections: "getTrackerFilterDropdownsList",
      screen: "ProspectsTR",
      orgId: context.bankuserDetails?.organization.orgId,
      isJsonReturnObject: true,
    };
    service.getLeadsData(postData).then((res: any) => {
      setFiltersData(res.data);
    });
  };

  const getSearchInput = () => (
    <div className="cs-search">
      <input
        type="search"
        placeholder={
          getTrackerType === TrackersEnum.RELATIONSHIPS
            ? "Search by Relationship "
            : "Search by Lead"
        }
        className="lead-search"
        onChange={(e) => handleTrackerSearch(e?.target?.value || "")}
        value={trackerSearch}
      />
    </div>
  );

  const getSwitchDisplay = () => (
    <div className="tracker-type-switch">
      <img
        src={
          trackerView === TrackerViewsEnum.GRID
            ? GridViewIcon
            : GridViewInActiveIcon
        }
        alt="GridViewIcon"
        className={`grid-view ${trackerView === TrackerViewsEnum.GRID ? "active" : "inactive"
          }`}
        onClick={() => {
          trackerView !== TrackerViewsEnum.GRID &&
            setTrackerView(TrackerViewsEnum.GRID);
          localStorage.setItem(
            `${getTrackerType}-trackerView`,
            TrackerViewsEnum.GRID
          );
        }}
      />
      {!currentUrl.includes("relationships") && <img
        src={
          trackerView === TrackerViewsEnum.LIST
            ? ListViewIcon
            : ListViewInActiveIcon
        }
        alt="ListViewIcon"
        className={`list-view ${trackerView === TrackerViewsEnum.LIST ? "active" : "inactive"
          }`}
        onClick={() => {
          trackerView !== TrackerViewsEnum.LIST &&
            setTrackerView(TrackerViewsEnum.LIST);
          localStorage.setItem(
            `${getTrackerType}-trackerView`,
            TrackerViewsEnum.LIST
          );
        }}
      />}
    </div>
  );

  const filterModalHandler = () => {
    getFilters();
    setFilterModal(true);
    setactiveFilter(true);
  };

  const closeFilterModalHandler = () => {
    setFilterModal(false);
    setactiveFilter(false);
  };

  const getClientDetailsByOrgId = (client: any) => {
    setInnerLoader(true);
    const data = {
      orgId: client.orgId,
      screen: "ProspectsTR",
      sections: "ClientsByOrg",
      isJsonReturnObject: false,
    };
    service
      .getClients(data)
      .then((response: AxiosResponse<any>) => {
        const lead = response.data.filter(
          (each: any) => each.clientId === client.clientId
        );
        if (lead[0]?.profileDocId) {
          service
            .getLogo(lead[0]?.profileDocId)
            .then((res: any) => {
              const data = {
                ...lead[0],
                photo: res?.data,
              };
              setSelectedClient(data);
              // setInnerLoader(false);
            })
            .catch((error: AxiosError) => {
              catchError(error, true);
            })
            .finally(() => {
              setInnerLoader(false);
            });
        } else {
          setSelectedClient(lead[0]);
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        setInnerLoader(false);
      });
  };

  const onItemClick = (data: any, menuOption: IMenuOptionsModel) => {
    if (menuOption?.type) {
      setMenuOption(menuOption);
      if (menuOption?.type === "view" && menuOption?.value) {
        let url = `${menuOption?.value}/${getTrackerType}/${data?.clientId}`;
        if (data?.clientProductsId) {
          url = url + `/${data?.clientProductsId}`;
        }
        navigate(url);
      }



      if (menuOption?.type) {
        getClientDetailsByOrgId(data);
      }
    }
  };
  const getFiltersDataHandler = (
    filterFormValues: any,
    selectedFilterObj: any
  ) => {
    setSelectedFilters(selectedFilterObj);
    setFilters(getTrackerType, selectedFilterObj);
    setTrackerData({
      search: trackerSearch,
      ...(sortOptions?.sortColumn ? sortOptions : {}),
      ...filterFormValues,
    });
    closeFilterModalHandler();
  };

  const getFilterText = (selectedValues: any, type: string) => {
    if (type === "producttype") {
      return filtersData?.[0]?.producttype?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "states") {
      return filtersData?.[0]?.states?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "industryTypes") {
      return filtersData?.[0]?.industrytypes?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "salesOrganizations") {
      return filtersData?.[0]?.salesOrganizations?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "assignmentType") {
      return filtersData?.[0]?.teamMembers?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "assignmentData") {
      return assignmentsObj.find((m: any) => m.value == selectedValues)?.text;
    }
    if (type === "nextAction") {
      return moment(selectedValues).format("MM/DD/YYYY");
    }
    if (type === "expectedClose") {
      return moment(selectedValues).format("MM/DD/YYYY");
    }
    if (type === "archive") {
      return archive?.find((m: any) => m.value == selectedValues)
        ?.text;
    }
  };

  const clearOpportunity = (selectedID: any) => {
    const newSelectedFilters = selectedFilters?.productType?.filter(
      (m: any) => m.id !== selectedID
    );
    setSelectedFilters({ ...selectedFilters, productType: newSelectedFilters });
    setFilters(getTrackerType, {
      ...selectedFilters,
      productType: newSelectedFilters,
    });
    setTrackerData({
      search: trackerSearch,
      ...(sortOptions?.sortColumn ? sortOptions : {}),
      productType: newSelectedFilters.map((m: any) => m.value),
      states: selectedFilters?.states?.map((m: any) => m.value),
      industryTypes: selectedFilters?.industryTypes?.map((m: any) => m.value),
      salesOrganizations: selectedFilters?.salesOrganizations?.map(
        (m: any) => m.value
      ),
      teamMembers: selectedFilters?.assignmentType?.map((m: any) => m.value),
      nextAction: selectedFilters?.nextAction
        ? moment(selectedFilters?.nextAction).format("MM/DD/YYYY")
        : null,
      expectedClose: selectedFilters?.expectedClose
        ? moment(selectedFilters?.expectedClose).format("MM/DD/YYYY")
        : null,
      archive: selectedFilters?.archive ?? null,
    });
  };

  const clearStates = (selectedID: any) => {
    const newSelectedFilters = selectedFilters?.states?.filter(
      (m: any) => m.id !== selectedID
    );
    setSelectedFilters({ ...selectedFilters, states: newSelectedFilters });
    setFilters(getTrackerType, {
      ...selectedFilters,
      states: newSelectedFilters,
    });
    setTrackerData({
      search: trackerSearch,
      ...(sortOptions?.sortColumn ? sortOptions : {}),
      states: newSelectedFilters.map((m: any) => m.value),
      productType: selectedFilters?.productType?.map((m: any) => m.value),
      industryTypes: selectedFilters?.industryTypes?.map((m: any) => m.value),
      salesOrganizations: selectedFilters?.salesOrganizations?.map(
        (m: any) => m.value
      ),
      teamMembers: selectedFilters?.assignmentType?.map((m: any) => m.value),
      nextAction: selectedFilters?.nextAction
        ? moment(selectedFilters?.nextAction).format("MM/DD/YYYY")
        : null,
      expectedClose: selectedFilters?.expectedClose
        ? moment(selectedFilters?.expectedClose).format("MM/DD/YYYY")
        : null,
      archive: selectedFilters?.archive ?? null,
    });
  };

  const clearindustryType = (selectedID: any) => {
    const newSelectedFilters = selectedFilters?.industryTypes?.filter(
      (m: any) => m.id !== selectedID
    );
    setSelectedFilters({
      ...selectedFilters,
      industryTypes: newSelectedFilters,
    });
    setFilters(getTrackerType, {
      ...selectedFilters,
      industryTypes: newSelectedFilters,
    });
    setTrackerData({
      search: trackerSearch,
      ...(sortOptions?.sortColumn ? sortOptions : {}),
      industryTypes: newSelectedFilters.map((m: any) => m.value),
      productType: selectedFilters?.productType?.map((m: any) => m.value),
      states: selectedFilters?.states?.map((m: any) => m.value),
      salesOrganizations: selectedFilters?.salesOrganizations?.map(
        (m: any) => m.value
      ),
      teamMembers: selectedFilters?.assignmentType?.map((m: any) => m.value),
      nextAction: selectedFilters?.nextAction
        ? moment(selectedFilters?.nextAction).format("MM/DD/YYYY")
        : null,
      expectedClose: selectedFilters?.expectedClose
        ? moment(selectedFilters?.expectedClose).format("MM/DD/YYYY")
        : null,
      archive: selectedFilters?.archive ?? null,
    });
  };
  const clearSalesOrganization = (selectedID: any) => {
    const newSelectedFilters = selectedFilters?.salesOrganizations?.filter(
      (m: any) => m.id !== selectedID
    );
    setSelectedFilters({
      ...selectedFilters,
      salesOrganizations: newSelectedFilters,
    });
    setFilters(getTrackerType, {
      ...selectedFilters,
      salesOrganizations: newSelectedFilters,
    });

    setTrackerData({
      search: trackerSearch,
      ...(sortOptions?.sortColumn ? sortOptions : {}),
      salesOrganizations: newSelectedFilters.map((m: any) => m.value),
      states: selectedFilters?.states?.map((m: any) => m.value),
      industryTypes: selectedFilters?.industryTypes?.map((m: any) => m.value),
      productType: selectedFilters?.productType?.map((m: any) => m.value),
      teamMembers: selectedFilters?.assignmentType?.map((m: any) => m.value),
      nextAction: selectedFilters?.nextAction
        ? moment(selectedFilters?.nextAction).format("MM/DD/YYYY")
        : null,
      expectedClose: selectedFilters?.expectedClose
        ? moment(selectedFilters?.expectedClose).format("MM/DD/YYYY")
        : null,
      archive: selectedFilters?.archive ?? null,
    });
  };
  const clearAssignment = (selectedID: any) => {
    const newSelectedFilters =
      selectedID === "My Leads"
        ? assignmentsObj.filter((m: any) => m.value !== selectedID)
        : selectedFilters?.assignmentType?.filter(
          (m: any) => m.id !== selectedID
        );

    setSelectedFilters({
      ...selectedFilters,
      assignmentType: newSelectedFilters,
    });
    setFilters(getTrackerType, {
      ...selectedFilters,
      assignmentType: newSelectedFilters,
    });

    setTrackerData({
      search: trackerSearch,
      ...(sortOptions?.sortColumn ? sortOptions : {}),
      teamMembers: newSelectedFilters.map((m: any) => m.value),
      states: selectedFilters?.states?.map((m: any) => m.value),
      industryTypes: selectedFilters?.industryTypes?.map((m: any) => m.value),
      productType: selectedFilters?.productType?.map((m: any) => m.value),
      salesOrganizations: selectedFilters?.salesOrganizations?.map(
        (m: any) => m.value
      ),
      nextAction: selectedFilters?.nextAction
        ? moment(selectedFilters?.nextAction).format("MM/DD/YYYY")
        : null,
      expectedClose: selectedFilters?.expectedClose
        ? moment(selectedFilters?.expectedClose).format("MM/DD/YYYY")
        : null,
      archive: selectedFilters?.archive ?? null,
    });
  };

  const clearNextAction = (selectedID: any) => {
    if (selectedFilters?.nextAction === selectedID) {
      setSelectedFilters({ ...selectedFilters, nextAction: null });
      setFilters(getTrackerType, { ...selectedFilters, nextAction: null });

      setTrackerData({
        search: trackerSearch,
        ...(sortOptions?.sortColumn ? sortOptions : {}),
        nextAction: null,
        states: selectedFilters?.states?.map((m: any) => m.value),
        productType: selectedFilters?.productType?.map((m: any) => m.value),
        industryTypes: selectedFilters?.industryTypes?.map((m: any) => m.value),
        salesOrganizations: selectedFilters?.salesOrganizations?.map(
          (m: any) => m.value
        ),
        teamMembers: selectedFilters?.assignmentType?.map((m: any) => m.value),
        expectedClose: selectedFilters?.expectedClose
          ? moment(selectedFilters?.expectedClose).format("MM/DD/YYYY")
          : null,
        archive: selectedFilters?.archive ?? null,
      });
    }
  };
  const expectedClose = (selectedID: any) => {
    if (selectedFilters?.expectedClose === selectedID) {
      setSelectedFilters({ ...selectedFilters, expectedClose: null });
      setFilters(getTrackerType, { ...selectedFilters, expectedClose: null });

      setTrackerData({
        search: trackerSearch,
        ...(sortOptions?.sortColumn ? sortOptions : {}),
        expectedClose: null,
        states: selectedFilters?.states?.map((m: any) => m.value),
        productType: selectedFilters?.productType?.map((m: any) => m.value),
        industryTypes: selectedFilters?.industryTypes?.map((m: any) => m.value),
        salesOrganizations: selectedFilters?.salesOrganizations?.map(
          (m: any) => m.value
        ),
        teamMembers: selectedFilters?.assignmentType?.map((m: any) => m.value),
        nextAction: selectedFilters?.nextAction
          ? moment(selectedFilters?.nextAction).format("MM/DD/YYYY")
          : null,
        archive: selectedFilters?.archive ?? null,
      });
    }
  };

  const clearArchive = (selectedID: any) => {
    setSelectedFilters({ ...selectedFilters, archive: null });
    setFilters(getTrackerType, { ...selectedFilters, archive: null });
    setTrackerData({
      search: trackerSearch,
      ...(sortOptions?.sortColumn ? sortOptions : {}),
      states: selectedFilters?.states?.map((m: any) => m.value),
      productType: selectedFilters?.productType?.map((m: any) => m.value),
      industryTypes: selectedFilters?.industryTypes?.map((m: any) => m.value),
      salesOrganizations: selectedFilters?.salesOrganizations?.map(
        (m: any) => m.value
      ),
      teamMembers: selectedFilters?.assignmentType?.map((m: any) => m.value),
      expectedClose: selectedFilters?.expectedClose
        ? moment(selectedFilters?.expectedClose).format("MM/DD/YYYY")
        : null,
      nextAction: selectedFilters?.nextAction
        ? moment(selectedFilters?.nextAction).format("MM/DD/YYYY")
        : null,
      archive: null

    });

  };

  const redirectFromAPI = async (btn: IActionBtnsModel) => {
    if (btn?.btnType === ActionBtnTypes.REDIRECT) {
      if (btn?.value) {
        const parseValue = parseInt(btn?.value);
        if (Number.isNaN(parseValue)) {
          sessionStorage.setItem("selectedButton", JSON.stringify(btn));
          navigate(btn?.value);
        } else navigate(parseValue);
      } else catchErrorGeneric("Something went wrong");
      // toast.error("Something went wrong.");
    }
  };

  // apis calls
  const updateEntity = (data: any) => {
    if (
      bankuserDetails?.organization?.orgId &&
      data?.clientId &&
      data?.clientProductsId
    ) {
      setInnerLoader(true);
      const payload = {
        sections: "assignPrequalQuestions",
        orgId: bankuserDetails?.organization?.orgId,
        clientProductsId: data?.clientProductsId,
        clientId: data?.clientId,
        moveToStatus: "NDA Created", // Todo: To be removed and after the flow integration is done
      };
      service
        .updateEntity(payload)
        .then((res) => {
          if (res?.data) {
            // Todo: replace below code with common function
            const sortedValues = res?.data?.sort(
              (a: IActionBtnsModel, b: IActionBtnsModel) =>
                a?.btnOrder - b?.btnOrder
            );
            sortedValues?.forEach(
              async (each: IActionBtnsModel) => await redirectFromAPI(each)
            );
          }
        })
        .catch((err) => catchError(err, true))
        .finally(() => setInnerLoader(false));
    } else catchErrorGeneric("Something went wrong");
    // toast.error("Something went wrong");
  };

  const handleRefreshTrackers = () => {
    setTrackerData({
      search: trackerSearch,
      ...(sortOptions?.sortColumn ? sortOptions : {}),
      ...selectedFilters,
    });
  };

  const handlePrimaryBtn = (e: any, data: any) => {
    e?.stopPropagation();
    updateEntity(data);
  };

  const handlePrimaryLink = (e: any, data: any) => {
    e?.stopPropagation();
  };

  const archive = [
    { text: "Show Archive Leads", value: 1 }

  ];

  const modifyingData = (data:ITrackerResponseModel[]) =>{
    if(data && data.length>0){
      data.sort((a,b)=>moment(b?.updatedDate).diff(moment(a?.updatedDate)))
    }
    return data;
  }

  return (
    <div
      className={`${baseConfig?.type}-container tracker-main container-fluid`}
    >
      {innerLoader ? <FinSpinner /> : <></>}
      {/* tracker header - start */}
      {selectedClient && (
        <CreateLeadMaster // from tracker
          firstBtn={true}
          fromTracker={true}
          leadData={selectedClient}
          refreshTrackers={handleRefreshTrackers}
          menuOption={menuOption}
          clientId={selectedClient?.clientId}
          pclientId={selectedClient?.parentClientId}
          selectedClient={selectedClient}
        />
      )}
      <div className="tracker-header">
        <div className="tracker-details">
          <div className="tracker-title">
            {baseConfig?.displayProduct ? (
              <div className="product-name">
                {JSON.parse(sessionStorage.getItem("selectedProduct") || "")
                  ?.productName || ""}
              </div>
            ) : (
              <></>
            )}
            <div className="title">{baseConfig?.title || ""}</div>
            {baseConfig?.displayCount ? (
              <div className="tracker-count">({trackerData?.length ?? 0})</div>
            ) : (
              <></>
            )}
          </div>
          {baseConfig?.createLead ? ( // first create Lead Btn
            <CreateLeadMaster
              genericTracker={true}
              refreshTrackers={handleRefreshTrackers}
              isConfirmToCreate={false}
              genericTrackerLead={selectedClient}
            />
          ) : (
            <></>
          )}
        </div>

        <div className="tracker-filter-search-main">
          <div className="filteredTextDiv">
            {selectedFilters?.productType?.map((m: any, index: number) => (
              <span className="filteredText" key={index}>
                {getFilterText(m, "producttype")}{" "}
                <FontAwesomeIcon
                  icon={faTimes}
                  onClick={() => clearOpportunity(m.id)}
                />{" "}
              </span>
            ))}
            {selectedFilters?.states?.map((m: any, index: number) => (
              <span className="filteredText" key={index}>
                {getFilterText(m, "states")}{" "}
                <FontAwesomeIcon
                  icon={faTimes}
                  onClick={() => clearStates(m.id)}
                />{" "}
              </span>
            ))}
            {selectedFilters?.industryTypes?.map((m: any, index: number) => (
              <span className="filteredText" key={index}>
                {getFilterText(m, "industryTypes")}{" "}
                <FontAwesomeIcon
                  icon={faTimes}
                  onClick={() => clearindustryType(m.id)}
                />{" "}
              </span>
            ))}
            {selectedFilters?.archive?.map(
              (m: any, index: number) => (
                <span className="filteredText" key={index}>
                  {getFilterText(m, "archive")}{" "}
                  <FontAwesomeIcon
                    icon={faTimes}
                    onClick={() => clearArchive(m.id)}
                  />{" "}
                </span>
              )
            )}
            {selectedFilters?.salesOrganizations?.map(
              (m: any, index: number) => (
                <span className="filteredText" key={index}>
                  {getFilterText(m, "salesOrganizations")}{" "}
                  <FontAwesomeIcon
                    icon={faTimes}
                    onClick={() => clearSalesOrganization(m.id)}
                  />{" "}
                </span>
              )
            )}
            {selectedFilters?.assignmentType?.includes("My Leads")
              ? selectedFilters?.assignmentType?.map(
                (m: any, index: number) => (
                  <span className="filteredText" key={index}>
                    {getFilterText(m, "assignmentData")}{" "}
                    <FontAwesomeIcon
                      icon={faTimes}
                      onClick={() => clearAssignment(m)}
                    />{" "}
                  </span>
                )
              )
              : selectedFilters?.assignmentType?.map(
                (m: any, index: number) => (
                  <span className="filteredText" key={index}>
                    {getFilterText(m, "assignmentType")}{" "}
                    <FontAwesomeIcon
                      icon={faTimes}
                      onClick={() => clearAssignment(m.id)}
                    />{" "}
                  </span>
                )
              )}
            {selectedFilters?.nextAction ? (
              <span className="filteredText">
                {getFilterText(selectedFilters?.nextAction, "nextAction")}{" "}
                <FontAwesomeIcon
                  icon={faTimes}
                  onClick={() => clearNextAction(selectedFilters?.nextAction)}
                />{" "}
              </span>
            ) : (
              ""
            )}
            {selectedFilters?.expectedClose ? (
              <span className="filteredText">
                {getFilterText(selectedFilters?.expectedClose, "expectedClose")}{" "}
                <FontAwesomeIcon
                  icon={faTimes}
                  onClick={() => expectedClose(selectedFilters?.expectedClose)}
                />{" "}
              </span>
            ) : (
              ""
            )}
          </div>
          {baseConfig?.displayViewSort ? (
            <div className="view-sort">
              <span className="view-text text">Viewing:</span>
              <select name="sort" id="sort">
                <option value="h2l">Highest to Lowest</option>
                <option value="l2h">Lowest to Highest</option>
              </select>
            </div>
          ) : (
            <></>
          )}
          {baseConfig?.searchLead ? getSearchInput() : <></>}
          {baseConfig?.filterLead ? (
            <Button
              className={`${activeFilter} filter-btn`}
              onClick={filterModalHandler}
            >
              <img src={FilterIcon} alt="FilterIcon" className="filter-icon" />
              <span className="filter-text">Filters</span>
            </Button>
          ) : (
            <></>
          )}
          {/* {baseConfig?.displaySecondHeader ? <>Slider</> : <></>} */}
          {baseConfig?.swicthDisplay ? getSwitchDisplay() : <></>}
        </div>
      </div>
      {/* tracker end - start */}

      {/* tracker inner - start */}
      <div className="tracker-inner-main">
        {/*  Tracker grid */}
        {trackerView === TrackerViewsEnum.GRID ? (
          // && trackerData && trackerData.length > 0 write this condition
          trackerData?.length > 0 ? (
            <TrackerModule
              config={trackerConfig}
              data={modifyingData(trackerData)}
              tileDropdown={tileDropdown}
              toggleTileDropdown={toggleTileDropdown}
              tileDropdownName="uuid"
              onItemClick={onItemClick}
              cardHandler={cardHandler}
              handlePrimaryBtn={handlePrimaryBtn}
              handlePrimaryLink={handlePrimaryLink}
            />
          ) : (
            <div className="not-found">No records found.</div>
          )
        ) : (
          trackerData?.length > 0 ? (
            <ListViewTracker
              config={trackerListConfig}
              data={trackerData}
              setTrackerData={setTrackerData}
              setSortOptions={setSortOptions}
              sortOptions={sortOptions}
              extraFields={{
                search: trackerSearch,
                ...getModifiedFilterValues(selectedFilters),
              }}
            />
          ) : (
            <div className="not-found">No records found.</div>
          )
        )}
      </div>
      {/* tracker inner - end */}

      {/* Modal for filter */}
      <ModalPopup
        show={filterModal}
        onHide={filterModalHandler}
        className="filter-modal"
        autoFocus={false}
      >
        <ModalPopup.Header closeButton onClick={closeFilterModalHandler}>
          Filters
        </ModalPopup.Header>
        <ModalPopup.Body>
          <FilterLeads
            getFiltersDataHandler={getFiltersDataHandler}
            filtersData={filtersData}
            filterType="trackersPageFilters"
            selectedFilters={selectedFilters}
            getTrackerType={getTrackerType}
            clearAllfiltervalues={clearAllfiltervalues}
            archiveOptions={archive}
          />
        </ModalPopup.Body>
      </ModalPopup>
    </div>
  );
};

export default GenericTracker;
